export default "__VITE_ASSET__66422416__"